import Error from './component/Error';

function NotFoundView() {
  return (
    <Error
      status={404}
      title="Page not found"
      description="The page you are looking for does not exist or has been moved."
    />
  );
}

export default NotFoundView;
